// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.card {
    border: 1px solid #ddd;
    height: 235px;
}

@media (max-width: 700px) {
    .card {
        width: 90%;
        margin-bottom: 10px;
    }
}

@media (min-width: 700px) and (max-width: 1300px) {
    .card {
        width: 47%;
        margin-right: 3%;
        margin-bottom: 10px;
    }
}

@media (min-width: 1200px) {
    .card {
        width: 31%;
        margin-right: 2%;
        margin-bottom: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/asset/style/auditlog/auditlogdumptile.css"],"names":[],"mappings":";AACA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,gBAAgB;QAChB,mBAAmB;IACvB;AACJ","sourcesContent":["\n.card {\n    border: 1px solid #ddd;\n    height: 235px;\n}\n\n@media (max-width: 700px) {\n    .card {\n        width: 90%;\n        margin-bottom: 10px;\n    }\n}\n\n@media (min-width: 700px) and (max-width: 1300px) {\n    .card {\n        width: 47%;\n        margin-right: 3%;\n        margin-bottom: 10px;\n    }\n}\n\n@media (min-width: 1200px) {\n    .card {\n        width: 31%;\n        margin-right: 2%;\n        margin-bottom: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
